// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__32_-a","LogoLoader":"Modal__LogoLoader__1VNL-","ModalStoreList":"Modal__ModalStoreList__2Af_T","ModalTitle":"Modal__ModalTitle__H24WX","Small":"Modal__Small__1ArY1","ModalFitToContent":"Modal__ModalFitToContent__qfQEP","ModalFullScreen":"Modal__ModalFullScreen__fExQU","ModalFullScreenNarrow":"Modal__ModalFullScreenNarrow__1pEZi","ModalHeader":"Modal__ModalHeader__1tbPq","CloseContainer":"Modal__CloseContainer__2yzqy","CloseIconContainer":"Modal__CloseIconContainer__1Px3o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 129
// module chunks = 0